import moment from "moment";

export function getAlarmDurationTextFormat(createTS, closeTS, isOpen): string {
    const duration = isOpen ? (new Date().getTime() - createTS) : (closeTS - createTS);
    const mdur = moment.duration(duration,'milliseconds');
    return mdur.format('HH:mm:ss', { trim: false }).replace(/,/g, '');
}

export function getAlarmDurationDHMSFormat(createTS, closeTS, isOpen = false, durationTs = null): string {
  const duration = durationTs || (isOpen ? (new Date().getTime() - createTS) : (closeTS - createTS));
  const days = Math.floor(moment.duration(duration).asDays());
  const hours = moment.duration(duration).hours();
  const minutes = moment.duration(duration).minutes();
  const seconds = moment.duration(duration).seconds();
  return `${days ? days + 'd' : ''} ${hours ? hours + 'h' : ''} ${minutes ? minutes + 'm' : ''} ${seconds}s`;
}